import type { AiPowerTranslation } from './en';

/** Arabic (Modern Standard). Pending review by native speakers, as the note in the interface says. */
export const aiPowerAr: AiPowerTranslation = {
  mcp: {
    preset: {
      label: 'ابدأ من خدمة جاهزة',
      other: 'خدمة أخرى (أدخل عنوانها)',
      hint: 'عناوين تنشرها الخدمات نفسها. اختر واحدة لملء الاسم والعنوان.',
      docs: 'صفحة الخدمة نفسها عن هذا العنوان',
      verified: 'تم التحقق من العنوان بصفحة الخدمة في {{date}}.',
      summaries: {
        'intercom-us': 'ابحث عن المحادثات وجهات الاتصال ومقالات مركز المساعدة في Intercom.',
        'intercom-eu': 'ابحث عن المحادثات وجهات الاتصال ومقالات مركز المساعدة في Intercom.',
        gorgias: 'اقرأ التذاكر والعملاء في مكتب المساعدة Gorgias.',
        stripe: 'ابحث عن العملاء والمدفوعات والاشتراكات والمبالغ المستردة في Stripe.',
        klaviyo: 'اقرأ ملفات العملاء والقوائم ونتائج الحملات في Klaviyo.',
        calendly: 'تحقق من الأوقات المتاحة والأحداث المجدولة في Calendly.',
        linear: 'ابحث عن المشكلات والمشاريع في Linear واقرأها.',
        notion: 'ابحث في الصفحات وقواعد البيانات في Notion واقرأها.',
        atlassian: 'ابحث عن مشكلات Jira وصفحات Confluence واقرأها.',
        asana: 'ابحث عن المهام والمشاريع في Asana واقرأها.',
        monday: 'ابحث عن اللوحات والعناصر في monday.com واقرأها.',
        sentry: 'ابحث عن الأخطاء والمشكلات في Sentry.',
        github: 'ابحث في المستودعات والمشكلات وطلبات الدمج على GitHub واقرأها.',
      },
      notes: {
        'intercom-us':
          'استخدم هذا العنوان إذا كانت مساحة عمل Intercom لديك مستضافة في الولايات المتحدة.',
        'intercom-eu':
          'استخدم هذا العنوان إذا كانت مساحة عمل Intercom لديك مستضافة في الاتحاد الأوروبي.',
        gorgias: 'تطلب Gorgias اسم حسابك عند تسجيل الدخول.',
        stripe: 'سجّل الدخول عبر OAuth، أو الصق مفتاح API الخاص بوكيل Stripe كرمز.',
        linear: 'لدى Linear أيضًا عنوان للقراءة فقط: https://mcp.linear.app/mcp/readonly.',
        asana: 'إذا طلبت Asana معرّف عميل، فأنشئ تطبيقًا في وحدة المطورين في Asana وأدخله.',
        github: 'أنشئ رمز وصول شخصيًا على GitHub والصقه كرمز.',
      },
      auth: {
        oauth: 'تسجّل الدخول من المتصفح. لا حاجة إلى رمز.',
        oauth_or_token: 'تسجّل الدخول من المتصفح، أو تلصق رمزًا من الخدمة.',
        token: 'تعطيك الخدمة رمزًا لتلصقه.',
      },
    },
    auth: {
      none: 'بلا تسجيل دخول أو رمز',
      token: 'الرمز {{masked}}',
      oauth: 'تم تسجيل الدخول عبر {{host}}',
      needsReconnect: 'توقف تسجيل الدخول عن العمل. سجّل الدخول مرة أخرى.',
      expires: 'يتجدد تلقائيًا قبل {{time}}',
    },
    actions: {
      signIn: 'سجّل الدخول',
      signInAgain: 'سجّل الدخول مرة أخرى',
      signOut: 'سجّل الخروج',
      edit: 'تعديل',
      remove: 'إزالة',
      catalog: 'الموارد والطلبات الجاهزة',
      signInLabel: 'سجّل الدخول إلى {{name}}',
      signOutLabel: 'سجّل الخروج من {{name}}',
      editLabel: 'عدّل {{name}}',
      removeLabel: 'أزل {{name}}',
      catalogLabel: 'اعرض ما تقدمه {{name}} إلى جانب الأدوات',
    },
    signIn: {
      title: 'سجّل الدخول إلى {{name}}',
      description:
        'تنتقل إلى الخدمة لتسجّل الدخول وتسمح لـ Hamnivo، ثم تعود إلى هنا. لا يرى Hamnivo كلمة مرورك أبدًا.',
      continue: 'تابع إلى الخدمة',
      manual: 'أدخل معرّف عميل',
      manualHint:
        'فقط إذا طلبته الخدمة: بعض الخدمات لا تسمح لـ Hamnivo بتسجيل نفسه. استخدم عنوان إعادة التوجيه أدناه عند إنشاء العميل هناك.',
      redirect: 'عنوان إعادة التوجيه',
      clientId: 'معرّف العميل',
      clientSecret: 'سر العميل',
      clientSecretHint: 'فقط إذا أعطتك الخدمة واحدًا.',
      needsClient:
        'هذه الخدمة لا تسمح لـ Hamnivo بتسجيل نفسه. أدخل معرّف العميل الذي أعطتك إياه الخدمة.',
      leaving: 'جارٍ الانتقال إلى الخدمة…',
      signedOut: 'تم تسجيل الخروج من {{name}}.',
    },
    signOut: {
      title: 'تسجيل الخروج من {{name}}؟',
      body: 'يطلب Hamnivo من الخدمة أن تنسى هذا الوصول، ويحذف تسجيل الدخول المحفوظ. تبقى الأدوات لكنها لا تعمل حتى تسجّل الدخول مرة أخرى أو تضيف رمزًا.',
      confirm: 'سجّل الخروج',
    },
    callback: {
      title: 'تسجيل الدخول',
      working: 'جارٍ إنهاء تسجيل الدخول…',
      done: 'تم تسجيل الدخول إلى {{name}}.',
      synced: 'أدواتها مدرجة ضمن الأدوات: راجع كل أداة قبل تشغيلها.',
      syncFailed: 'تم تسجيل الدخول، لكن تعذّر سرد الأدوات بعد. افحص الخدمة مرة أخرى.',
      refused: 'لم تسمح الخدمة بتسجيل الدخول.',
      failed: 'لم يكتمل تسجيل الدخول.',
      ended: 'انتهى تسجيل الدخول هذا أو بدأه شخص آخر. ابدأه من جديد من الأدوات.',
      missing: 'هذه الصفحة لإنهاء تسجيل الدخول. ابدأ واحدًا من الأدوات.',
      back: 'العودة إلى الأدوات',
    },
    edit: {
      title: 'تعديل {{name}}',
      description: 'غيّر اسمها أو عنوانها أو رمزها.',
      label: 'الاسم',
      url: 'العنوان',
      token: 'رمز جديد',
      tokenHint:
        'اتركه فارغًا للإبقاء على المحفوظ. الرمز الجديد يحل محل تسجيل الدخول. يُخزَّن مشفّرًا ولا يظهر مرة أخرى.',
      removeToken: 'احذف الرمز المحفوظ',
      removeSignIn: 'لإزالة تسجيل الدخول استخدم «سجّل الخروج».',
      urlWarning:
        'إذا تغيّر العنوان تعود الأدوات إلى المراجعة وتُقرأ قائمة الخدمة من جديد. يبقى الرمز المحفوظ فقط عندما يكون العنوان الجديد على الموقع نفسه، وينتهي تسجيل الدخول.',
      save: 'احفظ التغييرات',
      saved: 'تم تحديث {{name}}.',
      nothing: 'لم يتغير شيء.',
    },
    remove: {
      title: 'إزالة {{name}}؟',
      body: 'تُوقَف أدواتها وتخرج من القائمة، وتُلغى الطلبات المنتظرة عليها، ويُحذف رمزها أو تسجيل دخولها. ما فعلته يبقى في السجل. يمكنك ربط العنوان نفسه لاحقًا.',
      confirm: 'أزل',
      done: 'تمت إزالة {{name}}.',
    },
    catalog: {
      title: 'ما تقدمه {{name}}',
      description:
        'الموارد والطلبات الجاهزة التي عرضتها الخدمة عند آخر فحص، إلى جانب الأدوات. الكلمات بين علامتي الاقتباس من الخدمة.',
      checked: 'عُرضت {{time}}',
      neverChecked: 'افحص الخدمة أولًا لترى ما تقدمه.',
      resources: 'الموارد',
      resourcesNote:
        'مستندات وبيانات تقدمها الخدمة. يمكن للوكلاء الذين لديهم أداة “Read a resource” قراءة ما تشغّله فقط.',
      noResources: 'لا تعرض الخدمة أي موارد.',
      readable: 'يمكن للوكلاء قراءته',
      readableLabel: 'اسمح للوكلاء بقراءة {{name}}',
      readableHint: 'فقط عبر أداة “Read a resource”.',
      type: 'النوع',
      size: 'الحجم',
      uri: 'العنوان',
      fromService: 'من الخدمة',
      prompts: 'الطلبات الجاهزة',
      promptsNote: 'طلبات جاهزة تقدمها الخدمة. تُعرض لتراها أنت، ولا يستخدمها الوكلاء.',
      noPrompts: 'لا تعرض الخدمة أي طلبات جاهزة.',
      arguments: 'تطلب',
      required: 'مطلوب',
      needTool: 'يقرأ الوكلاء الموارد بأداة “Read a resource”. أضفها ضمن الأدوات ثم امنحها لوكيل.',
      saved: 'تم الحفظ.',
      loading: 'جارٍ تحميل ما تقدمه الخدمة',
    },
  },
  web: {
    badge: 'موقع إلكتروني',
    add: 'إضافة موقع',
    line: {
      reading: 'جارٍ القراءة الآن',
      waiting: 'في انتظار القراءة',
      never: 'لم يُقرأ بعد',
      last: 'قُرئ {{time}}',
    },
    dialog: {
      addTitle: 'أضف موقعًا إلكترونيًا',
      addDescription:
        'يقرأ Hamnivo صفحات الموقع ويُبقيها محدَّثة ليجيب الذكاء الاصطناعي منها. يلتزم بملف robots.txt الخاص بالموقع، ويقرأ ببطء، ويبقى داخل الموقع الذي تعطيه عنوانه.',
      editTitle: 'إعدادات الموقع',
      brand: 'العلامة التجارية',
      url: 'عنوان الموقع',
      urlHint:
        'الصفحة التي تبدأ منها القراءة، مثل https://example.com/help/. تُقرأ الصفحات الموجودة في هذا المجلد فقط.',
      urlRequired: 'أدخل عنوان الموقع.',
      urlInvalid: 'أدخل عنوانًا كاملًا يبدأ بـ https://.',
      name: 'الاسم',
      nameHint: 'يظهر في قائمة المصادر. إن تركته فارغًا يُستخدم اسم الموقع.',
      mode: 'ما الذي يُقرأ',
      modeSite: 'الموقع كله',
      modeSiteHint: 'خريطة الموقع (sitemap) والروابط بين صفحاته، داخل مجلد العنوان.',
      modePage: 'هذه الصفحة فقط',
      modePageHint: 'العنوان الذي أدخلته فقط.',
      maxPages: 'أقصى عدد من الصفحات',
      maxPagesHint: 'من 1 إلى 500.',
      maxPagesInvalid: 'أدخل عددًا صحيحًا من 1 إلى 500.',
      maxDepth: 'عدد الروابط التي تُتَّبع',
      maxDepthHint: 'يُحسب من الصفحة الأولى. القيمة 0 تقرأ الصفحة الأولى وخريطة الموقع فقط.',
      maxDepthInvalid: 'أدخل عددًا صحيحًا من 0 إلى 5.',
      schedule: 'القراءة من جديد',
      visibility: 'من يمكنه الحصول على إجابات منه',
      submit: 'إضافة الموقع',
      save: 'حفظ التغييرات',
      added: 'أُضيف {{name}}. يبدأ Hamnivo قراءته الآن.',
      saved: 'حُفظت إعدادات الموقع.',
      later: 'قد تستغرق القراءة الأولى بضع دقائق. يمكنك مغادرة هذه الصفحة.',
    },
    schedule: { daily: 'كل يوم', weekly: 'كل أسبوع', manual: 'عندما أطلب ذلك فقط' },
    panel: {
      title: 'الموقع الإلكتروني',
      address: 'العنوان',
      reads: 'ما الذي يقرؤه',
      readsSite: 'الموقع كله: حتى {{pages}} صفحة، وعمق الروابط {{depth}}',
      readsPage: 'هذه الصفحة فقط',
      schedule: 'القراءة من جديد',
      next: 'القراءة التالية {{time}}',
      pages: 'الصفحات المحفوظة',
      lastRead: 'آخر قراءة',
      never: 'لم يُقرأ هذا الموقع بعد.',
      state: {
        queued: 'في انتظار القراءة',
        running: 'جارٍ القراءة الآن',
        succeeded: 'تمت قراءته',
        partial: 'تمت قراءته مع مشكلات',
        failed: 'تعذّرت قراءته',
        never: 'لم يُقرأ بعد',
      },
      polling: 'يتحقق Studio من الجديد كل بضع ثوانٍ أثناء قراءة الموقع.',
      summary: {
        title: 'ما فعلته آخر قراءة',
        added: 'جديدة: {{total}}',
        updated: 'تغيّرت: {{total}}',
        unchanged: 'بلا تغيير: {{total}}',
        retired: 'أُزيلت: {{total}}',
        sitemaps: 'خرائط الموقع المقروءة: {{total}}',
        leftOut: 'ما تُرك',
        skipped: {
          robots: 'الموقع يطلب من القارئات الابتعاد (robots.txt): {{total}}',
          offsite: 'في موقع آخر: {{total}}',
          noindex: 'صفحات تطلب عدم فهرستها: {{total}}',
          type: 'ليست صفحة ويب ولا ملف PDF: {{total}}',
          duplicate: 'نسخ من صفحة قُرئت من قبل: {{total}}',
          empty: 'لا نص مقروء فيها: {{total}}',
        },
        problems: 'تعذّرت قراءتها',
        truncated:
          'توقفت القراءة قبل أن تصل إلى كل الصفحات بسبب حد الصفحات أو الوقت. ارفع الحد من الإعدادات لقراءة المزيد.',
        robots: {
          read: 'قُرئ ملف robots.txt الخاص بالموقع وجرى الالتزام به.',
          missing: 'لا يوجد ملف robots.txt في الموقع، فسُمح بكل الصفحات.',
          unreadable: 'تعذّرت قراءة ملف robots.txt الخاص بالموقع، فلم يُقرأ شيء.',
        },
      },
      actions: {
        sync: 'اقرأه الآن',
        syncLabel: 'اقرأ {{name}} الآن',
        queued: 'سيقرأ Hamnivo موقع {{name}} بعد لحظات.',
        settings: 'الإعدادات',
        settingsLabel: 'إعدادات {{name}}',
        showPages: 'عرض الصفحات',
        hidePages: 'إخفاء الصفحات',
      },
      pagesList: {
        title: 'الصفحات',
        loading: 'جارٍ تحميل الصفحات',
        empty: 'لا توجد صفحات بعد.',
        columns: { address: 'العنوان', state: 'الحالة', note: 'ملاحظة' },
        states: { ok: 'مقروءة', failed: 'فشلت', gone: 'أُزيلت' },
      },
    },
  },
  http: {
    title: 'أدوات مخصصة',
    description:
      'اربط خدمة ويب خاصة بك. استورد وصف OpenAPI الخاص بها، أو اكتب طلبًا واحدًا بنفسك. يصبح كل طلب أداة تنتظر مراجعتك قبل أن يستخدمها أي وكيل.',
    importLabel: 'استيراد وصف',
    writeLabel: 'اكتب طلبًا',
    loading: 'جارٍ تحميل الأدوات المخصصة',
    empty: 'لا توجد أدوات مخصصة بعد.',
    source: {
      kinds: { openapi: 'وصف مستورد', manual: 'مكتوب يدويًا' },
      status: { active: 'مفعّلة', disabled: 'متوقفة' },
      toolStatus: { review: 'بانتظار المراجعة', enabled: 'مفعّلة', disabled: 'متوقفة' },
      tools: 'الأدوات: {{total}}',
      review: 'بانتظار المراجعة: {{total}}',
      auth: {
        none: 'بلا بيانات اعتماد',
        bearer: 'رمز {{masked}}',
        header: 'سرّ في الترويسة {{header}} {{masked}}',
      },
      spec: 'من الوصف «{{title}}» {{version}}',
      requests: 'طلبات {{name}}',
      open: 'افتح',
      openLabel: 'افتح الأداة {{tool}}',
      editRequest: 'عدّل',
      editRequestLabel: 'عدّل الطلب {{tool}}',
      imported: 'مستورد: استورده مرة أخرى لتغييره.',
      addRequest: 'أضف طلبًا',
      importMore: 'استورد المزيد',
      edit: 'عدّل',
      editLabel: 'عدّل {{name}}',
      turnOff: 'أوقف',
      turnOn: 'شغّل',
      remove: 'أزل',
      removeLabel: 'أزل {{name}}',
      off: 'هذه الخدمة متوقفة، لذلك لا تعمل أدواتها.',
    },
    service: {
      name: 'اسم الخدمة',
      nameHint: 'الاسم الذي تجدها به في القائمة، مثل «نظام الطلبات».',
      baseUrl: 'عنوان الخدمة',
      baseUrlHint:
        'يذهب كل طلب إلى ما تحت هذا العنوان، مثل https://api.example.com/v1. يبدأ بـ https:// ولا يحتوي على ? أو #.',
      auth: {
        legend: 'كيف تُصادِق الطلبات',
        none: 'بلا بيانات اعتماد',
        noneHint: 'لخدمة لا تحتاج إليها.',
        bearer: 'رمز',
        bearerHint: 'يُرسل على صورة «Authorization: Bearer …».',
        header: 'سرّ في ترويسة',
        headerHint: 'يُرسل في الترويسة التي تسمّيها.',
        token: 'الرمز',
        tokenHint: 'يُخزّن مشفّرًا. لا يظهر منه إلا آخر أحرفه.',
        headerName: 'اسم الترويسة',
        headerNameHint: 'مثل X-Api-Key.',
        value: 'القيمة السرية',
        valueHint: 'تُخزّن مشفّرة. لا يظهر منها إلا آخر أحرفها.',
      },
      errors: {
        name: 'أعطِ الخدمة اسمًا.',
        baseUrl: 'أدخل العنوان، بادئًا بـ https://.',
        token: 'يتكوّن الرمز من 8 أحرف على الأقل.',
        headerName: 'استخدم أحرفًا وأرقامًا وشرطات وشرطات سفلية.',
        value: 'أدخل القيمة السرية.',
      },
    },
    importDialog: {
      title: 'استيراد وصف OpenAPI',
      titleMore: 'استورد المزيد من الأدوات إلى {{name}}',
      description:
        'يقرأ Hamnivo وصف OpenAPI 3، بصيغة JSON أو YAML، ويعرض الطلبات التي يمكنه تحويلها إلى أدوات. لا يُحفظ شيء حتى تضيفها.',
      where: 'أين الوصف؟',
      paste: 'لدي النص أو ملف',
      address: 'هو على عنوان ويب',
      text: 'الوصف',
      textHint: 'الصق JSON أو YAML هنا، أو اختر ملفًا. حتى 900,000 حرف.',
      file: 'اختر ملفًا',
      fileTooBig: 'هذا الملف كبير جدًا. اترك الطلبات التي لا تحتاج إليها، أو اكتبها يدويًا.',
      specUrl: 'عنوان الوصف',
      specUrlHint:
        'مثل https://api.example.com/openapi.json. يقرأه Hamnivo من خادمه، بالقواعد نفسها المطبّقة على كل عنوان.',
      read: 'اقرأ الوصف',
      needText: 'الصق الوصف أو اختر ملفًا أولًا.',
      needUrl: 'أدخل عنوان الوصف أولًا.',
      found: '«{{title}}» {{version}}: يمكن تحويل {{count}} طلبًا إلى أدوات.',
      foundUntitled: 'يمكن تحويل {{count}} طلبًا إلى أدوات.',
      none: 'لا يمكن تحويل أي طلب في هذا الوصف إلى أداة.',
      readAgain: 'اقرأ وصفًا آخر',
      servers: 'يقول الوصف إن الخدمة على',
      serversHint: 'هذا نص من الوصف. تحقق من العنوان قبل استخدامه.',
      authUnsupported:
        'يطلب الوصف نوعًا من تسجيل الدخول ({{kind}}) لا تستطيع الأدوات القيام به عنك. إذا كانت الخدمة تقبل أيضًا رمزًا أو مفتاحًا في ترويسة، فاختر ذلك أدناه.',
      operations: 'الطلبات التي ستتحول إلى أدوات',
      operationsHint:
        'يصبح كل منها أداة تنتظر مراجعتك. المختارة لك هي التي تقرأ فقط. أما الطلبات التي تغيّر شيئًا فاختيارها بيدك، ويوافق شخص على كل استخدام.',
      selectReads: 'اختر التي تقرأ فقط',
      selectAll: 'اختر الكل',
      selectNone: 'لا تختر شيئًا',
      chosen: 'المختار: {{count}}',
      already: 'أداة موجودة في هذه الخدمة',
      left: 'تُرك منه:',
      skipped: 'طلبات لا يمكن تحويلها إلى أدوات ({{count}})',
      submit: 'أضف الأدوات المختارة',
      needOne: 'اختر طلبًا واحدًا على الأقل.',
      added: 'أُضيفت {{count}} أدوات. تنتظر مراجعتك.',
    },
    endpointDialog: {
      addTitle: 'اكتب طلبًا',
      addTitleTo: 'أضف طلبًا إلى {{name}}',
      editTitle: 'عدّل {{tool}}',
      description:
        'طلب واحد تفهمه خدمتك. يُخبَر الذكاء الاصطناعي بما يفعله وبالتفاصيل التي عليه ملؤها.',
      editWarning: 'يعيد الحفظ هذه الأداة إلى المراجعة وينهي الطلبات التي تنتظر الموافقة.',
      title: 'اسم الأداة',
      titleHint: 'يراه فريقك، مثل «البحث عن طلب».',
      about: 'ما يُخبَر به الذكاء الاصطناعي عن عملها',
      aboutHint: 'قل متى تُستخدم وماذا تُرجع. اكتبه للذكاء الاصطناعي.',
      method: 'الطريقة',
      path: 'المسار',
      pathHint: 'يبدأ بـ /. اكتب {orderId} حيث تذهب قيمة، مثل /orders/{orderId}.',
      risk: 'ما يمكنها فعله',
      riskDefault: 'يُحدَّد من الطريقة',
      details: 'تفاصيل يملؤها الذكاء الاصطناعي',
      detailsHint: 'كل واحدة قيمة يرسلها الذكاء الاصطناعي مع الطلب.',
      noDetails: 'لا تفاصيل. يُرسل الطلب كما هو.',
      addDetail: 'أضف تفصيلًا',
      detailLabel: 'التفصيل {{n}}',
      removeDetail: 'أزل التفصيل {{n}}',
      missing: 'في المسار {{names}}، لكن لا تفصيل يملؤه.',
      fill: 'أضف {{name}}',
      detail: {
        name: 'الاسم',
        nameHint: 'ما يسميه به الذكاء الاصطناعي: أحرف وأرقام وشرطات سفلية.',
        place: 'يذهب في',
        places: {
          path: 'المسار',
          query: 'الاستعلام',
          header: 'ترويسة',
          body: 'جسم JSON',
        },
        key: 'الاسم في الطلب',
        keyHint: 'فقط إذا اختلف عن الاسم.',
        type: 'نوع القيمة',
        types: {
          string: 'نص',
          integer: 'عدد صحيح',
          number: 'رقم',
          boolean: 'نعم أو لا',
        },
        required: 'مطلوب دائمًا',
        requiredPath: 'مطلوب دائمًا لأنه في المسار',
        about: 'ما هو',
      },
      errors: {
        title: 'أعطِ الأداة اسمًا.',
        about: 'قل ما تفعله الأداة.',
        path: 'ابدأ المسار بـ /.',
        detailName: 'استخدم أحرفًا وأرقامًا وشرطات سفلية، وابدأ بحرف.',
        detailDuplicate: 'تفصيلان لهما الاسم نفسه.',
      },
      submitAdd: 'أضف الأداة',
      submitEdit: 'احفظ',
      added: 'أُضيفت {{name}}. تنتظر مراجعتك.',
      saved: 'حُفظت {{name}}. عادت إلى المراجعة.',
    },
    editDialog: {
      title: 'عدّل {{name}}',
      description: 'غيّر الاسم أو العنوان، أو استبدل بيانات الاعتماد.',
      name: 'اسم الخدمة',
      baseUrl: 'عنوان الخدمة',
      baseUrlWarning:
        'العنوان الجديد يعيد الأدوات إلى المراجعة. ولا تنتقل بيانات الاعتماد أبدًا إلى موقع آخر.',
      credential: 'بيانات الاعتماد',
      keep: 'أبقِها',
      replace: 'استبدلها',
      remove: 'أزلها',
      save: 'احفظ',
      saved: 'حُفظت {{name}}.',
      nothing: 'لم يتغيّر شيء.',
    },
    removeDialog: {
      title: 'هل تزيل {{name}}؟',
      body: 'تتوقف أدواتها وتختفي من القائمة، وتُلغى الطلبات التي تنتظرها، وتُحذف بيانات اعتمادها. ما فعلته الأدوات يبقى في سجل الإجراءات.',
      confirm: 'أزل',
      done: 'أُزيلت {{name}}.',
    },
    tool: {
      service: 'خدمة مخصصة',
      request: 'الطلب',
      titleLabel: 'اسم الأداة',
      descriptionLabel: 'ما يُخبَر به الذكاء الاصطناعي عن عملها',
      descriptionHint: 'يقرأ الذكاء الاصطناعي هذا بدل كلمات الوصف. راجعه قبل أن تشغّل الأداة.',
      errors: { title: 'أعطِ الأداة اسمًا.', description: 'قل ما تفعله الأداة.' },
    },
  },
  memoryCard: {
    title: 'ما يتذكره الذكاء الاصطناعي',
    open: 'فتح الذاكرة',
    none: 'لا شيء مُتذكَّر هنا: هذا الزائر ليس عميلًا معروفًا بعد.',
    off: 'الذكاء الاصطناعي لهذه العلامة لا يستخدم الذاكرة، فلا يصل شيء مما هنا إلى ردوده.',
    empty: 'لا شيء مُتذكَّر عن هذا العميل بعد.',
    note: 'يستخدم الذكاء الاصطناعي القيم الحالية فقط، وفقط إذا وافق العميل على أن يُتذكَّر.',
    thisChat: 'هذه المحادثة',
    pendingNote: 'لا تُستخدم حتى يؤكدها أحد.',
    review: 'مراجعة',
    reviewLabel: 'مراجعة {{label}}',
    correct: 'تصحيح',
    correctLabel: 'تصحيح {{label}}',
    delete: 'حذف',
    deleteLabel: 'حذف {{label}}',
    correctTitle: 'تصحيح «{{label}}»',
    correctBody: 'القيمة الجديدة تحل محل هذه. تبقى القيمة القديمة في السجل.',
  },
  playground: {
    title: 'جرّب الذكاء الاصطناعي',
    description:
      'تحدّث مع هذا الوكيل كما يفعل العميل، بالنموذج الذي يستخدمه فعلًا. يجيب من تعليماته ومعرفته. لا يُحفظ شيء، ولا يصل شيء إلى عميل أو إلى صندوق الوارد، ولا تُشغَّل أي أداة. كل رسالة تستهلك رموزًا (tokens) كالرد الحقيقي.',
    testOnly: 'للتجربة فقط: لا يُرسل ولا يُحفظ شيء',
    version: 'النسخة المراد تجربتها',
    versions: {
      draft: 'المسودة المحفوظة (النسخة {{version}})',
      published: 'النسخة المباشرة ({{version}})',
    },
    unsaved: 'هناك تغييرات غير محفوظة. تستخدم التجربة المسودة المحفوظة، فاحفظ أولًا لتجربتها.',
    noVersion: 'احفظ مسودة لتجربة هذا الوكيل.',
    startOver: 'ابدأ من جديد',
    you: 'أنت، في دور العميل',
    ai: 'الذكاء الاصطناعي',
    message: 'رسالتك',
    messageHint: 'اكتب ما قد يكتبه العميل.',
    send: 'إرسال',
    thinking: 'الذكاء الاصطناعي يجيب…',
    empty: 'اكتب رسالة لتبدأ. جرّب سؤالًا يطرحه عملاؤك كثيرًا.',
    tooLong: 'هذه المحادثة التجريبية طويلة. ابدأ من جديد لتواصل التجربة.',
    outcome: {
      customer_request: 'طلب العميل التحدث إلى شخص، فكانت المحادثة الحقيقية ستنتقل إلى فريقك.',
      assist_mode: 'هذا الوكيل يقترح ردودًا لفريقك فقط، فكانت المحادثة الحقيقية ستنتقل إليهم.',
      ai_blocked:
        'تعذّر على الذكاء الاصطناعي كتابة رد يلتزم بقواعده، فكانت المحادثة الحقيقية ستنتقل إلى فريقك.',
      other: 'كانت المحادثة الحقيقية ستنتقل إلى فريقك هنا.',
    },
    errors: {
      auth: 'رفض مزوّد النموذج المفتاح أو الحساب. تحقق من اتصال النموذج.',
      rate_limited: 'مزوّد النموذج يحدّ من الطلبات. حاول بعد قليل.',
      overloaded: 'مزوّد النموذج مشغول. حاول بعد قليل.',
      unavailable: 'مزوّد النموذج غير متاح الآن.',
      timeout: 'استغرق النموذج وقتًا طويلًا في الرد.',
      aborted: 'أُوقف الطلب.',
      invalid_request: 'لم يقبل مزوّد النموذج الطلب. تحقق من اسم النموذج وإعداداته.',
      content_filtered: 'أوقف مرشّح مزوّد النموذج الإجابة.',
      context_length: 'المحادثة أطول مما يتحمله النموذج. ابدأ من جديد.',
      no_credentials: 'لا يوجد مفتاح لهذا النموذج. أضف اتصال نموذج أولًا.',
      connection_disabled: 'اتصال النموذج متوقف. اختر اتصالًا آخر.',
      provider_mismatch: 'اتصال النموذج لمزوّد آخر غير الذي اخترته.',
      model_not_allowed: 'هذا النموذج غير مسموح به على الاتصال.',
      provider_not_supported: 'هذا النوع من النماذج غير مدعوم.',
      empty_reply: 'ردّ النموذج بلا شيء.',
      unknown: 'لم يرد النموذج.',
    },
    sources: 'المصادر التي استخدمها',
    actions: 'الأدوات التي طلبها',
    actionsNote: 'لا تُشغَّل الأدوات هنا أبدًا. يُظهر هذا ما كانت ستفعله محادثة حقيقية.',
    decisions: {
      would_run: 'كانت ستعمل فورًا',
      needs_approval: 'كانت ستطلب موافقة',
      denied: 'غير مسموح بها',
      invalid: 'تفاصيل غير صحيحة',
    },
    details: 'التفاصيل التي أرسلها',
    steps: 'الخطوات ({{total}})',
    stepsLabel: 'ما فعله الذكاء الاصطناعي لهذه الإجابة',
    stats: 'النموذج {{model}} · الرموز: {{input}} دخولًا، {{output}} خروجًا · {{time}}',
    statsNoModel: 'لم يُستدعَ أي نموذج · {{time}}',
  },
};
